import RTPList from '@/pages/requests/RTPList.vue'
import RTPListBack from '@/pages/requests/RTPListBack.vue'
import PaymentsDetailPage from '@/pages/requests/detailPages/RequestToPayDetailPage.vue'
import PaymentsDetailPageDemo from '@/pages/requests/detailPages/RequestToPayDetailPageDemo.vue'
import PaymentsFluxDetailPage from '@/pages/requests/detailPages/PaymentsFluxDetailPage.vue'
// import PaymentsTrashPage from '@/pages/services/payments/CMTrashPage.vue'
// import PaymentsDraftPage from '@/pages/services/payments/CMDraftPage.vue'
import PaymentsDraftEditPage from '@/pages/services/payments/TDraftEdit.vue'
import PaymentsDraftCreatePage from '@/pages/services/payments/TDraftCreate.vue'
import PaymentsCreation from '@/pages/requests/creationPages/capsules/TPayments.vue'
import PaymentsPilotage from '@/pages/statistics/StatisticsPage.vue'
// import PaymentsDebtorList from '@/pages/services/payments/CMDebtorList.vue'
import PaymentsDebtorList from '@/pages/requests/ContactDebtorList.vue'
// import PaymentsContactDebtorList from '@/pages/services/payments/CMContactDebtorList.vue'
import PaymentsNegotiation from '@/pages/requests/negotiationPages/CMTransactionEdit.vue'
import PaymentsFlux from '@/pages/requests/PaymentsFlux.vue'
import OrphanFlux from '@/pages/requests/OrphanFlux.vue'

import ImportFiles from '@/pages/pain008/ImportFiles.vue'
import Consultation from '@/pages/pain008/Consultations.vue'
import Traitement from '@/pages/pain008/Traitement.vue'

import Pacs008Import from '@/pages/pacs008/ImportFiles.vue'
import Pacs008SCTTraitement from '@/pages/pacs008/SCT/Traitement.vue'
import Pacs008SCTConsultation from '@/pages/pacs008/SCT/Consultations.vue'
import Pacs008Parametres from '@/pages/pacs008/Parametres.vue'
import Pacs008SCTTransaction from '@/pages/pacs008/SCT/TransactionList.vue'

import Pacs008SDDTransaction from '@/pages/pacs008/SDD/TransactionList.vue'
import Pacs008SDDConsultation from '@/pages/pacs008/SDD/Consultations.vue'
import Pacs008SDDTraitement from '@/pages/pacs008/SDD/Traitement.vue'




export default [
  {
    // path: '/payments/inbox/:showPreloader',
    path: '/rtp/list/:direction/:modeFilter',
    alias: ['/account/inbox/', '/payments/'],
    component: RTPList
  },
  {
    // path: '/payments/inbox/:showPreloader',
    path: '/rtp/listBack/:direction/:modeFilter/:loadFilters',
    alias: ['/account/inbox/', '/payments/'],
    component: RTPListBack
  },
  /* {
    path: '/payments/sendbox/:tab',
    alias: ['/account/senbox/:tab', '/sendbox/:tab'],
    component: PaymentsSentboxPage
  }, */
  {
    path: '/payments/request-details/:id',
    component: PaymentsFluxDetailPage
  },
  {
    path: '/payments/transaction-details/:id/',
    alias: ['/account/transaction-details/:id/', '/transaction-details/:id/'],
    component: PaymentsDetailPage
  },
  {
    path: '/payments/transaction-details-demo/',
    alias: ['/account/transaction-details-demo/', '/transaction-details-demo/'],
    component: PaymentsDetailPageDemo
  },
  // {
  //   path: '/payments/trash/',
  //   alias: ['/account/trash/', '/trash/'],
  //   component: PaymentsTrashPage
  // },
  // {
  //   path: '/payments/draft/',
  //   component: PaymentsDraftPage
  // },
  {
    path: '/payments/draft/edit/',
    component: PaymentsDraftEditPage
  },
  {
    path: '/payments/draft/create/',
    component: PaymentsDraftCreatePage
  },
  {
    path: '/payments/newPayments/',
    alias: ['/account/createPayments', '/createPayments/'],
    component: PaymentsCreation
  },
  {
    path: '/payments/debtorList/',
    alias: ['/account/createPayments/debtorList', '/createPayments/debtorList/'],
    component: PaymentsDebtorList
  },
  /* {
    path: '/payments/contactDebtorList/',
    alias: ['/account/createPayments/contactDebtorList', '/createPayments/contactDebtorList/'],
    component: PaymentsContactDebtorList
  }, */
  {
    path: '/payments/pilotage/',
    alias: ['/account/pilotage/', '/pilotage/'],
    component: PaymentsPilotage
  },
  {
    path: '/payments/negotiate/',
    component: PaymentsNegotiation
  },
  {
    path: '/payments/requests/:modeFilter/',
    component: PaymentsFlux
  },
  {
    path: '/payments/orphan/:modeFilter/',
    component: OrphanFlux
  },
  {
    path: '/pain008/import/',
    component: ImportFiles
  },
  {
    path: '/pain008/traitement/',
    component: Traitement
  },
  {
    path: '/pain008/consultation/',
    component: Consultation
  },
  {
    path: '/pacs008/import/',
    component: Pacs008Import
  },
  {
    path: '/pacs008/SCT/traitement/',
    component: Pacs008SCTTraitement
  },
  {
    path: '/pacs008/SCT/consultation/:id',
    component: Pacs008SCTConsultation,
    props: true
  },
  {
    path: '/pacs008/SCT/transactions/',
    component: Pacs008SCTTransaction
  },
  {
    path: '/pacs008/SCT/transactions/:id',
    component: Pacs008SCTTransaction,
    props: true
  },
  {
    path: '/pacs008/parametres/',
    component: Pacs008Parametres
  },
  {
    path: '/pacs008/SDD/consultation/:id',
    component: Pacs008SDDConsultation,
    props: true
  },
  {
    path: '/pacs008/SDD/transactions/',
    component: Pacs008SDDTransaction
  },
  {
    path: '/pacs008/SDD/transactions/:id',
    component: Pacs008SDDTransaction,
    props: true
  },
  {
    path: '/pacs008/SDD/traitement/',
    component: Pacs008SDDTraitement
  }

]
